import React from "react";
import Container from "../../components/Container/Container";
import LoginForm from "../../components/LoginForm/LoginForm";

const Login = () => {
  return (
    <Container>
      <LoginForm />
    </Container>
  );
};

export default Login;
